/** Presentation metadata for base / bull / bear scenarios (kept dependency-free). */

export const SCENARIO_META = {
  base: { key: 'base', label: 'Base', color: '#805AD5', direction: 0 },
  bull: { key: 'bull', label: 'Bull', color: '#2F855A', direction: 1 },
  bear: { key: 'bear', label: 'Bear', color: '#C53030', direction: -1 },
};

export const SCENARIO_ORDER = ['base', 'bull', 'bear'];

/** Scenario keys that can be toggled on top of the always-present base. */
export const OPTIONAL_SCENARIO_KEYS = ['bull', 'bear'];
